import { includes, isEmpty, isNil } from 'ramda';
import { isNilOrEmptyString } from 'ramda-extension';

import { USER_ROLES } from 'constants/general';

export const getFirstRole = (roleStructureMap) =>
	(roleStructureMap && roleStructureMap[0] && roleStructureMap[0].role) || '';

export const findRole = (role, structureMap) => structureMap.find((structure) => structure.role === role);

export const getNewRole = (currentRole, roleStructureMap) => {
	// no active role
	if (isEmpty(currentRole)) {
		return getFirstRole(roleStructureMap);
	}
	// active role is no longer in new structure
	if (isNil(findRole(currentRole, roleStructureMap))) {
		return getFirstRole(roleStructureMap);
	}

	return currentRole;
};

export const isSameOrUndefined = (prop, obj1, obj2) => (obj1[prop] === obj2[prop] ? obj1[prop] : undefined);

// Checking user access for given role on page
export const checkRole = (
	page,
	role,
	hasKMPSubordinates,
	hasUserSubordinates,
	hasSellerPpzDashboardPerm,
	hasManagerDashboardPerm,
) => {
	switch (page) {
		case 'dashboard':
			if (includes(role, [USER_ROLES.SELLER, USER_ROLES.PPZ]) || isNilOrEmptyString(role)) {
				return hasSellerPpzDashboardPerm;
			} else if (role === USER_ROLES.GROUP_MANAGER) {
				return hasManagerDashboardPerm;
			} else {
				return false;
			}
		case 'producedProduction':
			return role !== USER_ROLES.GUARANTOR;
		case 'campaignsListManagement':
			const checkAccess = () => {
				if (isNil(role) || role === '' || role === USER_ROLES.PPZ) {
					return false;
				} else if (role === USER_ROLES.SELLER) {
					return hasKMPSubordinates;
				} else {
					return true;
				}
			};

			return checkAccess();
		case 'campaigns':
			return !isNilOrEmptyString(role);
		case 'contacts':
			return !isNilOrEmptyString(role);
		case 'taskStatistics':
			return !isNilOrEmptyString(role) && role !== USER_ROLES.PPZ && role !== USER_ROLES.GUARANTOR;
		case 'subordinateUsers':
			return hasUserSubordinates;
		default:
			return true;
	}
};
